document.addEventListener("DOMContentLoaded", function () {
  var bundleSwiper = new Swiper(".diy-bundle-list ", {
    slidesPerView: 3,
    grid: {
      rows: 2,
    },
    spaceBetween: 16,
    pagination: {
      el: ".diy-bundle-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".diy-bundle-next",
      prevEl: ".diy-bundle-pre",
    },
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
    breakpoints: {
      1000: {
        slidesPerView: 3,
        spaceBetween: 16,
        grid: {
          rows: 2,
        },
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 8,
        grid: {
          rows: 2,
        },
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 8,
        grid: {
          rows: 2,
        },
      },
    },
  });

  const container = document.querySelector(".diy-bundle-module");
  if (!container) return;

  const moneyFormat = container.dataset.moneyFormat || "${{amount}}";
  const currencyIso = container.dataset.currencyIso || "USD";
  const noDecimalsIso = ["BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"];

  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(/[^0-9]/g, "");
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;

      if (isNaN(number) || number == null) return 0;

      // 如果是零小数货币，则不除以 100
      if (noDecimalsIso.includes(currencyIso)) {
        number = (number * 1.0).toFixed(0);
      } else {
        number = (number / 100.0).toFixed(precision);
      }

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", "");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  // 存储已选产品（格式: {slot: 位置, product: 产品信息, uniqueId: 唯一标识}）
  let selectedProducts = [];
  const MAX_SLOTS = 2; // 固定2个位置
  let uniqueIdCounter = 0; // 唯一标识计数器

  const addToCartBtn = container.querySelector(".add-cart-btn");
  if (!addToCartBtn) return;

  const finalTotalEl = container.querySelector(".final-total");
  const originalTotalEl = container.querySelector(".original-total");
  const saveAmountEl = container.querySelector(".save-amount");
  const discountText = addToCartBtn.dataset.discount;

  // 从折扣字符串或文本中提取数字
  function parseDiscount(str) {
    if (!str) {
      // 尝试从页面文本中提取 (例如 "enjoy 25% OFF")
      const textEl = document.querySelector(".bundle-paragraph-1");
      if (textEl) {
        const textMatch = textEl.textContent.match(/(\d+)%/);
        if (textMatch) return parseFloat(textMatch[1]);
      }
      return NaN;
    }
    const match = str.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[0]) : NaN;
  }

  const discountValue = parseDiscount(discountText);

  // 从固定槽位获取产品信息
  function getProductFromFixedSlot(slotEl) {
    if (!slotEl) return null;
    const variantSelect = slotEl.querySelector(".slot-variant-select");
    let variantId, price, priceText, comparePriceText, comparePrice;

    if (variantSelect.tagName === "SELECT") {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      variantId = selectedOption.value;
      price = parseInt(selectedOption.dataset.price);
      priceText = selectedOption.dataset.priceText;
      comparePriceText = selectedOption.dataset.comparePriceText;
      comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice) : price;
    } else {
      variantId = variantSelect.value;
      price = parseInt(variantSelect.dataset.price);
      priceText = slotEl.querySelector(".slot-pro-price").innerHTML.trim();
      const compareEl = slotEl.querySelector(".slot-pro-compare-price");
      comparePriceText = compareEl ? compareEl.innerHTML.trim() : "";
      comparePrice = compareEl ? (compareEl.dataset.comparePrice ? parseInt(compareEl.dataset.comparePrice) : price) : price;
    }

    return {
      id: slotEl.dataset.productId,
      name: slotEl.querySelector(".slot-pro-title").textContent.trim(),
      priceText: priceText,
      price: price,
      comparePrice: comparePrice,
      comparePriceText: comparePriceText,
      image: slotEl.querySelector(".slot-pro-img").src,
      variant: variantId
    };
  }

  // 初始化固定产品
  const fixedSlot = document.querySelector(".bundle-slot.fixed-slot");
  if (fixedSlot) {
    uniqueIdCounter++;
    const fixedProduct = getProductFromFixedSlot(fixedSlot);
    selectedProducts.push({
      slot: 1,
      product: fixedProduct,
      uniqueId: uniqueIdCounter,
      isFixed: true
    });

    // 监听固定产品的变体切换
    const fixedSelect = fixedSlot.querySelector(".slot-variant-select");
    if (fixedSelect && fixedSelect.tagName === "SELECT") {
      fixedSelect.addEventListener("change", function() {
        const selectedOption = this.options[this.selectedIndex];
        fixedSlot.querySelector(".slot-pro-price").innerHTML = selectedOption.dataset.priceText;
        
        // 更新原价显示
        const comparePriceEl = fixedSlot.querySelector(".slot-pro-compare-price");
        if (selectedOption.dataset.comparePriceText) {
          if (comparePriceEl) {
            comparePriceEl.innerHTML = selectedOption.dataset.comparePriceText;
            comparePriceEl.style.display = "inline";
          } else {
            // 如果原本没有原价，创建一个
            const priceWrapper = fixedSlot.querySelector(".slot-pro-price-wrapper");
            const newCompareEl = document.createElement("span");
            newCompareEl.className = "slot-pro-compare-price";
            newCompareEl.innerHTML = selectedOption.dataset.comparePriceText;
            priceWrapper.appendChild(newCompareEl);
          }
        } else if (comparePriceEl) {
          comparePriceEl.style.display = "none";
        }

        if (selectedOption.dataset.image) {
          fixedSlot.querySelector(".slot-pro-img").src = selectedOption.dataset.image;
        }
        
        // 更新 selectedProducts 中的数据
        const item = selectedProducts.find(p => p.slot === 1 && p.isFixed);
        if (item) {
          item.product.variant = selectedOption.value;
          item.product.price = parseInt(selectedOption.dataset.price);
          item.product.priceText = selectedOption.dataset.priceText;
          item.product.comparePriceText = selectedOption.dataset.comparePriceText || "";
          item.product.image = fixedSlot.querySelector(".slot-pro-img").src;
        }
        updateTotalPrice();
      });
    }
  }

  // 从DOM中动态提取产品信息
  function getProductFromDOM(productEl) {
    if (!productEl) return null;

    const productId = productEl.dataset.id;
    const variantSelect = productEl.querySelector(".variant-select");
    let variantId, price, priceText, comparePriceText, comparePrice;

    if (variantSelect.tagName === "SELECT") {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      variantId = selectedOption.value;
      price = parseInt(selectedOption.dataset.price);
      priceText = selectedOption.dataset.priceText;
      comparePriceText = selectedOption.dataset.comparePriceText;
      comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice) : price;
    } else {
      variantId = variantSelect.value;
      price = parseInt(variantSelect.dataset.price);
      priceText = productEl.querySelector(".bundle-pro-price").innerHTML.trim();
      const compareEl = productEl.querySelector(".bundle-pro-compare-price");
      comparePriceText = compareEl ? compareEl.innerHTML.trim() : "";
      comparePrice = compareEl ? (compareEl.dataset.comparePrice ? parseInt(compareEl.dataset.comparePrice) : price) : price;
    }

    // 提取产品信息
    return {
      id: productId,
      name: productEl.querySelector(".bundle-pro-title").textContent.trim(),
      priceText: priceText,
      price: price, // 现在是分(cents)
      comparePrice: comparePrice,
      comparePriceText: comparePriceText,
      image: productEl.querySelector(".bundle-pro-img").src,
      variant: variantId
    };
  }

  // 监听变体选择变化
  document.querySelectorAll(".variant-select").forEach(select => {
    if (select.tagName === "SELECT") {
      select.addEventListener("change", function() {
        const productEl = this.closest(".diy-bundle-product");
        const selectedOption = this.options[this.selectedIndex];
        
        // 更新价格显示
        const priceDisplay = productEl.querySelector(".bundle-pro-price");
        priceDisplay.innerHTML = selectedOption.dataset.priceText;
        priceDisplay.dataset.price = selectedOption.dataset.price;

        // 更新原价显示
        const comparePriceEl = productEl.querySelector(".bundle-pro-compare-price");
        if (selectedOption.dataset.comparePriceText) {
          if (comparePriceEl) {
            comparePriceEl.innerHTML = selectedOption.dataset.comparePriceText;
            comparePriceEl.style.display = "inline";
          } else {
            const priceWrapper = productEl.querySelector(".bundle-pro-price-wrapper");
            const newCompareEl = document.createElement("span");
            newCompareEl.className = "bundle-pro-compare-price";
            newCompareEl.innerHTML = selectedOption.dataset.comparePriceText;
            priceWrapper.appendChild(newCompareEl);
          }
        } else if (comparePriceEl) {
          comparePriceEl.style.display = "none";
        }

        // 更新产品图片
        const productImg = productEl.querySelector(".bundle-pro-img");
        if (productImg && selectedOption.dataset.image) {
          productImg.src = selectedOption.dataset.image;
          // 如果使用了懒加载，可能需要同时更新 data-src
          if (productImg.hasAttribute('data-src')) {
            productImg.setAttribute('data-src', selectedOption.dataset.image);
          }
        }
      });
    }
  });

  // 初始化：监听左侧产品的添加按钮
  container.querySelectorAll(".add-to-set").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const productEl = this.closest(".diy-bundle-product");
      addToSet(productEl);
    });
  });

  // Handle click on empty slot to scroll to product list on mobile
  container.addEventListener("click", function(e) {
    const emptySlot = e.target.closest(".bundle-slot.empty");
    if (emptySlot && window.innerWidth <= 768) {
      const listBox = container.querySelector(".diy-bundle-list-box");
      if (listBox) {
        listBox.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });

  // 添加产品到套装（找到第一个空位置，允许重复添加）
  function addToSet(productEl) {
    // 检查是否还有空位置
    if (selectedProducts.length >= MAX_SLOTS) {
      return;
    }

    // 动态从DOM获取产品信息
    const product = getProductFromDOM(productEl);
    if (!product) return;

    // 找到第一个空位置
    const emptySlot = getFirstEmptySlot();
    if (emptySlot) {
      uniqueIdCounter++; // 生成唯一标识
      // 添加到已选列表
      selectedProducts.push({
        slot: parseInt(emptySlot.dataset.slot),
        product: product,
        uniqueId: uniqueIdCounter, // 用于区分重复产品
      });

      // 更新UI（传递唯一标识）
      renderSelectedProduct(emptySlot, product, uniqueIdCounter);
      updateTotalPrice();
    }
  }

  // 获取第一个空位置
  function getFirstEmptySlot() {
    for (let i = 1; i <= MAX_SLOTS; i++) {
      const slot = document.querySelector(`.bundle-slot[data-slot="${i}"]`);
      if (slot.classList.contains("empty")) {
        return slot;
      }
    }
    return null;
  }

  // 渲染已选产品到指定位置（增加唯一标识参数）
  function renderSelectedProduct(slotElement, product, uniqueId) {
    // 移除按钮携带uniqueId，而非product.id
    slotElement.innerHTML = `
                <button class="remove" data-uniqueid="${uniqueId}">×</button>
                <img src="${product.image}" alt="${product.name}" class="slot-pro-img">
                <div class="slot-pro-info">
                  <p class="slot-pro-title">${product.name}</p>
                  <div class="slot-pro-price-wrapper">
                    <span class="slot-pro-price">${product.priceText}</span>
                    ${product.comparePriceText ? `<span class="slot-pro-compare-price">${product.comparePriceText}</span>` : ''}
                  </div>
                </div>
            `;
    slotElement.classList.remove("empty");
    slotElement.classList.add("filled");

    // 移除事件：根据uniqueId删除
    const removeBtn = slotElement.querySelector(".remove");
    removeBtn.addEventListener("click", function () {
      const targetUniqueId = parseInt(this.dataset.uniqueid);
      removeFromSet(targetUniqueId);
    });
  }

  // 从套装中移除产品（根据uniqueId删除，支持删除重复产品）
  function removeFromSet(targetUniqueId) {
    // 找到要移除的产品（根据uniqueId）
    const index = selectedProducts.findIndex(
      (item) => item.uniqueId === targetUniqueId
    );
    if (index === -1) return;

    const removedItem = selectedProducts.splice(index, 1)[0];

    // 清空对应位置
    const slot = document.querySelector(
      `.bundle-slot[data-slot="${removedItem.slot}"]`
    );
    if (slot) {
      slot.innerHTML = `<div class="add-icon">+</div>`;
      slot.classList.add("empty");
      slot.classList.remove("filled");
    }

    // 更新总价
    updateTotalPrice();
  }

  // 更新总价
  function updateTotalPrice() {
    // 累加所有已选产品价格 (cents)
    const total = selectedProducts.reduce(
      (sum, item) => sum + item.product.price, 0
    );
    // 累加所有已选产品的原始价格 (cents)
    const originalSum = selectedProducts.reduce(
      (sum, item) => sum + (item.product.comparePrice || item.product.price), 0
    );

    let finalPrice = total;

    const variantStr = selectedProducts
      .map((item) => item.product.variant)
      .filter(Boolean)
      .join(",");

    // 如果 discountValue 是百分比（如 25），则转化为折扣系数 0.75
    // 如果 discountValue 是系数（如 0.75），则保持
    let multiplier = 1;
    if (selectedProducts.length >= 2 && !isNaN(discountValue)) {
      if (discountValue >= 1) {
        multiplier = (100 - discountValue) / 100;
      } else if (discountValue > 0) {
        multiplier = discountValue;
      }
      finalPrice = Math.round(total * multiplier);
    }

    if (variantStr) {
      addToCartBtn.removeAttribute("disabled");
      addToCartBtn.setAttribute("data-variant-id", variantStr);
    } else {
      addToCartBtn.setAttribute("disabled", "disabled");
      addToCartBtn.setAttribute("data-variant-id", "");
    }

    // 使用 innerHTML 确保包含 HTML 标签的价格（如 Transcy 插件生成的标签）能正常渲染
    finalTotalEl.innerHTML = formatMoney(finalPrice);

    // 如果最终价格小于原始价格总和，则显示原价和节省金额
    if (finalPrice < originalSum) {
      originalTotalEl.innerHTML = formatMoney(originalSum);
      
      // 计算节省金额并格式化
      const saveCents = originalSum - finalPrice;
      // 这里可以尝试获取 "Save" 的多语言翻译，目前保持硬编码或根据上下文
      saveAmountEl.innerHTML = `Save ${formatMoney(saveCents)}`;
      
      saveAmountEl.style.display = "flex";
      originalTotalEl.style.display = "inline";
    } else {
      originalTotalEl.innerHTML = "";
      saveAmountEl.innerHTML = "";
      saveAmountEl.style.display = "none";
      originalTotalEl.style.display = "none";
    }
    
  }

  // 复制折扣码功能
  const copyBtn = document.querySelector(".copy-code-btn");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      const code = this.dataset.code;
      navigator.clipboard.writeText(code).then(() => {
        const originalText = this.textContent;
        this.textContent = "COPIED";
        this.classList.add("copied");
        setTimeout(() => {
          this.textContent = originalText;
          this.classList.remove("copied");
        }, 2000);
      });
    });
  }

  updateTotalPrice();
});
